import React, { useEffect, useState } from "react";
import { ExternalLink, Landmark } from "lucide-react";
import api from "@/lib/api";

export default function GovernmentGuidelines() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/government-resources").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="ca-container py-12">
      <h1 className="font-display text-3xl sm:text-4xl font-bold text-slate-900 flex items-center gap-2">
        <Landmark className="h-8 w-8 text-teal" /> Consumer Help & Government Guidelines
      </h1>
      <div className="mt-3 rounded-xl bg-slate-50 border border-slate-200 p-4 text-sm text-slate-600">
        This content is for general information only and is not legal advice. Rules, procedures, jurisdiction, and
        deadlines may vary. Consult a qualified professional for advice regarding your circumstances.
      </div>
      <div className="mt-8 grid md:grid-cols-2 gap-5">
        {items.map((g) => (
          <a key={g.id} href={g.link} target="_blank" rel="noreferrer" data-testid={`gov-resource-${g.id}`}
            className="rounded-2xl border border-slate-200 bg-white p-6 hover:border-teal-brand/40 hover:shadow-sm transition-all">
            <p className="font-semibold text-slate-900 flex items-center gap-1.5">{g.title} <ExternalLink className="h-4 w-4 text-slate-400" /></p>
            <p className="text-sm text-slate-600 mt-2">{g.desc}</p>
            <div className="mt-3 text-xs text-slate-400 flex flex-wrap gap-x-4 gap-y-1">
              <span>Source: {g.source}</span>
              <span>Jurisdiction: {g.jurisdiction}</span>
              <span>Last reviewed: {g.reviewed}</span>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
}
